import type { UserPermissions } from "@/context/PermissionContext";

/** Sidebar order: admin dashboard → leads → remaining menu items. */
const HOME_ROUTE_CANDIDATES: Array<{
  permission: keyof UserPermissions;
  path: string;
}> = [
  { permission: "canManageAdminDashboard", path: "/admin-dashboard" },
  { permission: "canManageLeads", path: "/lead" },
  { permission: "canManageRoles", path: "/manage-role" },
  { permission: "canManageCustomers", path: "/manage-customer" },
  { permission: "canManagePartners", path: "/manage-partner" },
  { permission: "canManageLenders", path: "/manage-lender" },
  // { permission: "canManageTermSheet", path: "/term-sheet" },
  { permission: "canManageCalculator", path: "/rental-calculator" },
  { permission: "canManageLogin", path: "/manage-login" },
  { permission: "canManageSupplier", path: "/manage-supplier" },
  { permission: "canManagePurchaseOrder", path: "/manage-purchase-order" },
  { permission: "canManageRentalSchedule", path: "/rental-schedule-dashboard" },
  { permission: "canManageRevenue", path: "/manage-revenue" },
  { permission: "canManageRentalInvoice", path: "/manage-rental-invoice" },
  { permission: "canManagePostDisbursement", path: "/manage-post-disbursement" },
  { permission: "canManagePortfolio", path: "/manage-portfolio" },
];

export function getDefaultHomePath(permissions: UserPermissions): string | null {
  for (const { permission, path } of HOME_ROUTE_CANDIDATES) {
    if (permissions[permission]) return path;
  }
  return null;
}
